import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9F6F0] py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <Button
          variant="ghost"
          onClick={() => navigate("/")}
          className="mb-6"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Retour
        </Button>

        <div className="bg-white rounded-lg shadow-lg p-8 sm:p-12">
          <h1 className="text-4xl font-bold text-[#2C2C2C] mb-4">Conditions d'Utilisation</h1>
          <p className="text-sm text-[#5C5C5C] mb-8">Dernière mise à jour : 3 juin 2026</p>

          <div className="space-y-6 text-[#2C2C2C] leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold mb-3">1. Acceptation des Conditions</h2>
              <p>
                En accédant et en utilisant ce site web et notre application mobile, vous acceptez d'être lié par ces conditions d'utilisation. Si vous n'êtes pas d'accord avec l'une de ces conditions, veuillez ne pas utiliser notre service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">2. Description du Service</h2>
              <p>
                Le Mystère de la Croix est une plateforme de vente d'ebook chrétien. Nous proposons à la vente l'ebook "Le Mystère de la Croix : L'espérance qui change tout" au prix de 10,000 Francs Congolais (CDF). Le paiement s'effectue via Mobile Money (Orange Money, M-Pesa, Airtel Money) traité par notre partenaire Bkapay.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">3. Achat et Paiement</h2>
              <p className="mb-2"><strong>3.1 Prix</strong></p>
              <p className="mb-3">Le prix de l'ebook est de 10,000 CDF. Tous les prix sont exprimés en Francs Congolais et incluent toutes les taxes applicables.</p>
              
              <p className="mb-2"><strong>3.2 Modes de Paiement</strong></p>
              <p className="mb-3">Nous acceptons les paiements via Orange Money, M-Pesa (Vodacom) et Airtel Money. Les transactions sont sécurisées par Bkapay.</p>
              
              <p className="mb-2"><strong>3.3 Confirmation</strong></p>
              <p className="mb-3">Une fois votre paiement confirmé, vous recevrez un email contenant le lien de téléchargement sécurisé de l'ebook.</p>
              
              <p className="mb-2"><strong>3.4 Échec de Paiement</strong></p>
              <p>Si votre paiement échoue, aucun montant ne sera débité. Vous pouvez réessayer avec le même mode de paiement ou en choisir un autre.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">4. Livraison et Accès</h2>
              <p className="mb-2"><strong>4.1 Livraison Numérique</strong></p>
              <p className="mb-3">
                L'ebook est livré numériquement via un lien de téléchargement envoyé par email immédiatement après la confirmation du paiement.
              </p>
              
              <p className="mb-2"><strong>4.2 Limite de Téléchargement</strong></p>
              <p className="mb-3">
                Chaque lien de téléchargement est valable pour un maximum de 3 téléchargements. Après cette limite, le lien expire pour des raisons de sécurité.
              </p>
              
              <p className="mb-2"><strong>4.3 Format</strong></p>
              <p>L'ebook est fourni au format PDF compatible avec la plupart des appareils (ordinateurs, tablettes, smartphones).</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">5. Propriété Intellectuelle</h2>
              <p className="mb-3">
                L'ebook "Le Mystère de la Croix" et tout son contenu (texte, images, design) sont protégés par les lois sur le droit d'auteur et la propriété intellectuelle. L'achat vous accorde une licence personnelle et non transférable pour lire l'ebook.
              </p>
              <p className="mb-2"><strong>Il est strictement interdit de :</strong></p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Reproduire, copier ou distribuer l'ebook sans autorisation</li>
                <li>Revendre ou transférer votre copie à d'autres personnes</li>
                <li>Modifier, adapter ou créer des œuvres dérivées</li>
                <li>Publier le contenu en ligne ou sur des plateformes de partage</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">6. Politique de Remboursement</h2>
              <p>
                En raison de la nature numérique du produit et de la livraison instantanée, <strong>aucun remboursement n'est possible une fois que le lien de téléchargement a été envoyé</strong>. Nous vous encourageons à lire attentivement la description du produit avant l'achat.
              </p>
              <p className="mt-3">
                <strong>Exception :</strong> En cas de problème technique empêchant le téléchargement, contactez-nous immédiatement. Nous ferons notre possible pour résoudre le problème ou émettre un remboursement si nécessaire.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">7. Utilisation du Service</h2>
              <p className="mb-2">Vous vous engagez à :</p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Fournir des informations exactes et à jour lors de l'achat</li>
                <li>Utiliser des moyens de paiement légitimes</li>
                <li>Ne pas tenter de contourner les mesures de sécurité</li>
                <li>Ne pas utiliser le service à des fins illégales ou non autorisées</li>
                <li>Respecter la propriété intellectuelle de l'ebook</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">8. Limitation de Responsabilité</h2>
              <p className="mb-3">
                Dans la mesure permise par la loi, Le Mystère de la Croix ne sera pas responsable des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs résultant de l'utilisation ou de l'impossibilité d'utiliser notre service.
              </p>
              <p>
                Nous ne garantissons pas que le service sera ininterrompu, sécurisé ou exempt d'erreurs. Nous nous réservons le droit de modifier ou d'interrompre le service à tout moment.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">9. Données Personnelles</h2>
              <p>
                La collecte et l'utilisation de vos données personnelles sont régies par notre Politique de Confidentialité. En utilisant notre service, vous consentez à la collecte et l'utilisation de vos informations conformément à cette politique.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">10. Modifications des Conditions</h2>
              <p>
                Nous nous réservons le droit de modifier ces conditions d'utilisation à tout moment. Les modifications entreront en vigueur dès leur publication sur cette page. Votre utilisation continue du service après les modifications constitue votre acceptation des nouvelles conditions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">11. Droit Applicable</h2>
              <p>
                Ces conditions d'utilisation sont régies par les lois de la République Démocratique du Congo. Tout litige relatif à ces conditions sera soumis à la juridiction exclusive des tribunaux compétents de la RDC.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-3">12. Contact</h2>
              <p className="mb-2">
                Pour toute question concernant ces conditions d'utilisation, veuillez nous contacter :
              </p>
              <div className="bg-gray-50 p-4 rounded-lg mt-3">
                <p><strong>Le Mystère de la Croix</strong></p>
                <p>Email : contact@mysterecroix.com</p>
                <p>Site web : https://ebook-foi-rdc.emergent.host</p>
                <p>Région : République Démocratique du Congo</p>
              </div>
            </section>

            <section className="border-t pt-6 mt-8">
              <p className="text-sm text-[#5C5C5C]">
                En effectuant un achat sur notre plateforme, vous confirmez avoir lu, compris et accepté ces conditions d'utilisation.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;